/**
 * Portfolio Section for Assistant Profile
 * Handles portfolio images with S3 upload
 */
import { Card } from "@/components/ui/card";
import PortfolioUpload from "./PortfolioUpload";

export default function PortfolioSection({ portfolio, setPortfolio, token, onImagesUploaded }) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-2">Portfolio Images</h2>
      <p className="text-white/50 mb-6">Add your best work samples (up to 100 images)</p>
      
      <PortfolioUpload
        portfolio={portfolio}
        setPortfolio={setPortfolio}
        token={token}
        maxImages={100}
        onUploadComplete={onImagesUploaded}
      />
    </Card>
  );
}
